import React from 'react';
import { Card, Form, Input, Button, Typography, Space, message, Checkbox } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/common/security/AuthContext';

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values: { username: string; password: string; remember?: boolean }) => {
    const ok = await login(values.username, values.password, !!values.remember);
    if (ok) {
      navigate('/home');
    } else {
      message.error('Invalid username or password.');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f6f7f8',
        padding: 16,
        boxSizing: 'border-box',
      }}
    >
      <Card style={{ borderRadius: 12, width: '100%', maxWidth: 460 }} bodyStyle={{ padding: 24 }}>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <Title level={5} style={{ margin: 0 }}>Project Information Platform</Title>
          <Title level={4} style={{ margin: 0 }}>Sign In</Title>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item name="username" label="Username" rules={[{ required: true, message: 'Please enter your username' }]}>
              <Input size="large" placeholder="username" />
            </Form.Item>
            <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Please enter your password' }]}>
              <Input.Password size="large" placeholder="••••••••" />
            </Form.Item>
            <Form.Item name="remember" valuePropName="checked" style={{ marginBottom: 12 }}>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" block size="large">Sign In</Button>
            </Form.Item>
          </Form>
          <Text type="secondary">© 2025 Project Information Platform. All rights reserved.</Text>
        </Space>
      </Card>
    </div>
  );
};

export default Login;


